import { useTranslation } from 'react-i18next';

import { ReactComponent as NotificationIcon } from 'assets/icons/Notification.svg';
import EmptyStateView from 'components/EmptyStateView/EmptyStateView';

import Notification from './Notification/Notification';
import useNotifications from '../NotificationsProvider/useNotifications';

const NotificationsList = () => {
  const { t } = useTranslation();
  const { notificationsState } = useNotifications();

  if (!notificationsState.length) {
    return (
      <EmptyStateView Icon={NotificationIcon} title={t('no_notifications')}>
        {t('empty_notifications')}
      </EmptyStateView>
    );
  }

  return (
    <div className="flex flex-col p-2 md:max-h-[512px] overflow-y-auto">
      {notificationsState.map((notification) => (
        <Notification key={notification.id} {...notification} />
      ))}
    </div>
  );
};

export default NotificationsList;
